export const ALL_ORDER = `/admin/order/list`;
export const SINGLE_ORDER = `/admin/order/details/`;
export const EXPORT_TO_CSV = `/admin/order/export-to-csv`;
export const ORDER_PAPER = `/admin/order/papers/`;
export const UPDATE_PAPER_BUNDLE = `/admin/order/update-paper-bundle`;
export const UPDATE_PAPER_CUSTOM = `/admin/order/update-paper-custom`;
export const APPROVE_COD = `/admin/order/approve-cod/`;
export const EDIT_ORDER_TOKEN = `/admin/order/edit-order-token/`;

export const ORDER_PREVIEW = `/order/order-preview`;
export const ORDER_CHECKOUT = `/order/checkout`;
export const ORDER_LIST = `/order/list`;
export const ORDER_BY_ID = `/order/details/`;
export const ORDER_PAYMENT = `/payment/save-status/`;
export const GET_ORDER = `/payment/razor/order/`;
export const MAIL_INVOICE = `/order/mail-invoice`;
export const INVOICE_PREVIEW = `/order/order-preview`;
